@if (!adding && !provisioningInProgress) {
  <div class="not-provisioned">
    <h4>EcoEHS is not provisioned for this tenant</h4>
    <button mat-raised-button class="mat-accent" (click)="startProvisioning()">Provision Now</button>
  </div>
}

@if (adding && !provisioningInProgress) {
  <div class="tile-wrapper">
    <form #newInstanceForm="ngForm" (ngSubmit)="submitForm()">
      <mat-card>
        <mat-card-title>New EcoEHS Instance</mat-card-title>
        <mat-card-subtitle>Create a new instance of EcoEHS for this tenant</mat-card-subtitle>
      </mat-card>
      <mat-card>
        <mat-card-title>Initial User</mat-card-title>
        <mat-card-subtitle>This is the first user, who can then add others</mat-card-subtitle>
        <mat-card-content>
          <mat-radio-group name="userCreateMode" required [(ngModel)]="instance.UserCreateMode">
            <mat-radio-button value="AddMe">
              Add Me
            </mat-radio-button>
            &nbsp;
            <mat-radio-button value="CreateNew">
              Create New User
            </mat-radio-button>
          </mat-radio-group>
          @if (instance.UserCreateMode === 'CreateNew') {
            <div>
              <mat-form-field>
                <mat-icon matPrefix>perm_identity</mat-icon>
                <input matInput
                  placeholder="Admin Username"
                  required
                  #username="ngModel"
                  name="username"
                  [(ngModel)]="instance.UserName"
                  min="6"
                  pattern="^(\S{6,50})$"/>
                @if (instance.UserCreateMode === 'CreateNew' && username.valid) {
                  <mat-icon matSuffix class="valid">done</mat-icon>
                }
                @if (instance.UserCreateMode === 'CreateNew' && username.errors && (username.dirty || username.touched || username.submitted)) {
                  <mat-icon matSuffix class="invalid">error_outline</mat-icon>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-icon matPrefix>security</mat-icon>
                <input matInput
                  placeholder="Admin Password"
                  type="password"
                  required
                  #password="ngModel"
                  name="password"
                  [(ngModel)]="instance.Password"
                  pattern="^(\S{6,50})$"/>
                @if (instance.UserCreateMode === 'CreateNew' && password.valid) {
                  <mat-icon matSuffix class="valid">done</mat-icon>
                }
                @if (instance.UserCreateMode === 'CreateNew' && password.errors && (password.dirty || password.touched || password.submitted)) {
                  <mat-icon matSuffix class="invalid">error_outline</mat-icon>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-icon matPrefix>security</mat-icon>
                <input matInput
                  placeholder="Repeat Password"
                  type="password"
                  required
                  #passwordRepeat="ngModel"
                  [(ngModel)]="passRepeat"
                  name="passwordRepeat"
                  [pattern]="'^('+escapeRegExp(instance.Password)+')$'" />
                @if (instance.UserCreateMode === 'CreateNew' && passwordRepeat.valid) {
                  <mat-icon matSuffix class="valid">done</mat-icon>
                }
                @if (instance.UserCreateMode === 'CreateNew' && passwordRepeat.errors && (passwordRepeat.dirty || passwordRepeat.touched || passwordRepeat.submitted)) {
                  <mat-icon matSuffix class="invalid">error_outline</mat-icon>
                }
              </mat-form-field>
              <br />
              <br />
              <mat-form-field>
                <input matInput
                  placeholder="First Name"
                  required
                  #firstName="ngModel"
                  name="firstName"
                  [(ngModel)]="instance.FirstName"
                  pattern="^([\S*]+(?: \S*)*)$"
                  [maxlength]="30"/>
                @if (userMode === 'CreateNew' && firstName.valid) {
                  <mat-icon matSuffix class="valid">done</mat-icon>
                }
                @if (userMode === 'CreateNew' && firstName.errors && (firstName.dirty || firstName.touched || firstName.submitted)) {
                  <mat-icon matSuffix class="invalid">error_outline</mat-icon>
                }
              </mat-form-field>
              <mat-form-field>
                <input matInput
                  placeholder="Last Name"
                  required
                  #lastName="ngModel"
                  name="lastName"
                  [(ngModel)]="instance.LastName"
                  pattern="^([\S*]+(?: \S*)*)$"
                  [maxlength]="30" />
                @if (userMode === 'CreateNew' && lastName.valid) {
                  <mat-icon matSuffix class="valid">done</mat-icon>
                }
                @if (userMode === 'CreateNew' && lastName.errors && (lastName.dirty || lastName.touched || lastName.submitted)) {
                  <mat-icon matSuffix class="invalid">error_outline</mat-icon>
                }
              </mat-form-field>
              <br />
              <br />
              <mat-form-field class="full-width">
                <mat-icon matPrefix>email</mat-icon>
                <input matInput
                  placeholder="Email Address"
                  type="email"
                  required
                  email
                  #email="ngModel"
                  name="email"
                  [(ngModel)]="instance.Email"
                  pattern="^[a-zA-Z0-9.!#$%&'’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$" />
                @if (userMode === 'CreateNew' && email.valid) {
                  <mat-icon matSuffix class="valid">done</mat-icon>
                }
                @if (userMode === 'CreateNew' && email.errors && (email.dirty || email.touched || email.submitted)) {
                  <mat-icon matSuffix class="invalid">error_outline</mat-icon>
                }
              </mat-form-field>
            </div>
          }
        </mat-card-content>
      </mat-card>
      <mat-card>
        <mat-card-title>Select Environment</mat-card-title>
        <mat-card-subtitle>The environment to install this instance of EcoEHS on.</mat-card-subtitle>
        <mat-card-content>
          <mat-select placeholder="Environment"
            [(ngModel)]="instance.EnvironmentId"
            #environment="ngModel"
            required
            name="environment">
            @for (env of environments; track env) {
              <mat-option [value]="env.Id">{{env.Name}}</mat-option>
            }
          </mat-select>
          @if (environment.valid) {
            <mat-icon matSuffix class="valid">done</mat-icon>
          }
          @if (environment.errors && (environment.dirty || environment.touched || environment.submitted)) {
            <mat-icon matSuffix class="invalid">error_outline</mat-icon>
          }
        </mat-card-content>
      </mat-card>
      <mat-card>
        <mat-card-title>EcoID</mat-card-title>
        <mat-card-subtitle>Does the tenant require provisioning with EcoID enabled?</mat-card-subtitle>
        <mat-card-content>
          <input hidden matInput>
          <mat-checkbox [(ngModel)]="instance.IsEcoIdTenant" #IsEcoIdTenant="ngModel" name="isEcoIdTenant">Provision Tenant with EcoID Enabled</mat-checkbox>
        </mat-card-content>
      </mat-card>
      <mat-card>
        <mat-card-actions>
          <button mat-raised-button class="mat-accent" [disabled]="!newInstanceForm.valid" (disabledChange)="newInstanceForm.valid = $event">Save</button>
        </mat-card-actions>
      </mat-card>
    </form>
  </div>
}

@if (!adding && provisioningInProgress) {
  <div class="tile-wrapper">
    <mat-card>
      <mat-card-title>Provisioning new EcoEHS Instance</mat-card-title>
      <mat-card-subtitle>You can close this window and the provisioning will continue in the background</mat-card-subtitle>
    </mat-card>
    <mat-card>
      <mat-card-title>Progress</mat-card-title>
      <mat-card-content>
        @if (provisioningJob) {
          <job-liveview [jobId]="provisioningJob"  (finished)="jobComplete($event)"></job-liveview>
        }
      </mat-card-content>
    </mat-card>
  </div>
}
